import { useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import Loader from '../Layout/Loader';
import {  BindGrid, exportToExcel,  setFocus, setTitle } from '../Common/Common';
import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { getCommonData } from '../Common/CommanServices';
import { useNavigate } from "react-router-dom";

const CityMaster = ({ open,setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false)
    const [CountryOption, setCountryOption] = useState([]);
    const [MenuText, setMenuText] = useState("City Master");

    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    })

    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })

    const [SaveData, setSaveData] = useState({
        CityID: "0",
        Country: "",
        CityName: "",
        Active: true
    });

    const handleClear = async () => {
        setSaveData({
            CityID: "0",
            Country: "",
            CityName: "",
            Active: true
        });
        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        setIsUpdate(!isUpdate)
    }

    useEffect(() => {
        setTitle('CityMaster', setOpen);
        setFocus('txtCountry');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);

    useEffect(() => {
        getCityData();
    }, [filterData.PageIndex, isUpdate]);

    const handleSubmit = async () => {
        const loginCodeString = String(LoginUserCode);
        setIsLoading(true)
        let data = {
            ...SaveData, Token, LoginUserCode: loginCodeString
        }
        post(`${API_SERVER}/api/Master/InsertUpdateCityMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);
                handleClear();
                getCityData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
            setIsLoading(false)
        });
    }

    const getCityData = async (Type = 'S') => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...filterData, Type: Type, Token, LoginUserCode: loginCodeString
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Master/ShowExCityMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                const gridDataStr = res.gridData;
                const cleanedGridDataStr = gridDataStr.trim().replace(/\r\n/g, '');
                const gridDataJson = JSON.parse(cleanedGridDataStr);
                if (Type === 'S') {
                    setTableData({
                        ...tableData,
                        gridData: gridDataJson,
                        totalRecord: res.totalRecord
                    });
                }
                else {
                    exportToExcel(gridDataJson, 'CityMaster');
                }
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.totalRecord <= 0) {
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]

                    })
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message,)
            }
            setIsLoading(false)
        })
    }

    const handleEditData = async (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, CityID: ID
        }
        post(`${API_SERVER}/api/Master/EditCityMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);
                setIsLoading(false);
                const editRecordStr = res.editRecord;
                const cleanededitRecordStr = editRecordStr.trim().replace(/\r\n/g, '');
                const editRecordJson = JSON.parse(cleanededitRecordStr);
                setSaveData({
                    CityID: ID,
                    Country: editRecordJson[0]['Country'],
                    CityName: editRecordJson[0]['City Name'],
                    Active: (editRecordJson[0]['Active'] === 'YES' ? true : false)
                });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.message !== "") {
               AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus)
            }
            setIsLoading(false);
        })
    }

    const handleDeleteData = async (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, CityID: ID
        }
        post(`${API_SERVER}/api/Master/DeleteCityMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);
               getCityData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message,)                
            }
            setIsLoading(false);
        })
    }
    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
        })
        getCityData();
    }
    const handleDownloadExcel = async () => {
        getCityData('E');
    }

    const getCountry = () => {
        setCountryOption([]);
        let temp = {
            Type: "GetCountry",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CountryOptionData = res.autoCompleteData || [];
                setCountryOption(CountryOptionData);
            } else {
                setCountryOption([]);
            }
        });
    };
    let CountryOptionArr = []
    for (let i = 0; i < CountryOption.length; i++) {
        let mydata = CountryOption[i]?.values
        CountryOptionArr.push(mydata)
    };

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtCityName") };
                                                }}
                                                label='Country'
                                                placeholder="Country"
                                                maxLength='50'
                                                options={CountryOptionArr}
                                                id='txtCountry'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getCountry()}
                                                inputValue={SaveData.Country ? SaveData.Country : ''}
                                                onInputChange={(event, newInputValue) => setSaveData({
                                                    ...SaveData, Country: newInputValue
                                                })
                                                }
                                            />
                                            
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">City<span className="Required">*</span></label>
                                            <input
                                                id='txtCityName'
                                                type="text"
                                                maxLength="100"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('chkActive')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter City'
                                                value={SaveData.CityName}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, CityName: e.target.value.toLocaleUpperCase()
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="chkActive"
                                                name='Active'
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('btnSave')
                                                    };
                                                }}
                                                checked={SaveData.Active}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Active: e.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            {SaveData.CityID !== '0' ? (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                                </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindGrid tableData={tableData} setFilterData={setFilterData} filterData={filterData} searchHandle={searchHandle}  handleEditData={handleEditData} handleDeleteData={handleDeleteData} FormName='CityMaster' />
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
     
        </main>
    )
}
export default CityMaster